import React from 'react';
import { FormattedMessage } from 'react-intl';
import { AdminDatePicker } from '.';

interface IEndSessionDatePickerProps {
  value: Date | null;
  onChange: (date: Date | null) => void;
}

export const EndSessionDatePicker = (props: IEndSessionDatePickerProps) => {
  return (
    <AdminDatePicker
      {...props}
      label={<FormattedMessage id='addSession:endDate' />}
    />
  )
};
